import { useEffect } from 'react';

const SUFIJO = 'SOEM Partners Group';
const BASE_URL = 'https://soempg.com';

function setMeta(selector, attr, value) {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [, name] = selector.match(/\[(?:name|property)="([^"]+)"\]/) || [];
    if (!name) return;
    el.setAttribute(selector.includes('property=') ? 'property' : 'name', name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

/**
 * Título y descripción por página.
 *
 * El sitio es una SPA: index.html trae UN solo <title> y UNA sola meta
 * description, así que sin esto las 13 páginas se indexaban en Google con
 * exactamente el mismo texto (por eso el resultado de /about mostraba el
 * mismo resumen que la portada). Cada página llama a este hook con lo suyo.
 *
 * Nota: Google renderiza JavaScript, así que lee estos valores. Aun así el
 * HTML inicial conserva los de la portada, que es el fallback correcto.
 */
export default function usePageMeta({ title, description, path }) {
  useEffect(() => {
    const completo = title ? `${title} | ${SUFIJO}` : SUFIJO;
    document.title = completo;

    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[property="og:title"]', 'content', completo);
    setMeta('meta[property="og:description"]', 'content', description);

    if (path) {
      const url = `${BASE_URL}${path}`;
      setMeta('meta[property="og:url"]', 'content', url);
      let canonical = document.head.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }
      canonical.setAttribute('href', url);
    }
  }, [title, description, path]);
}
